import { createMuiTheme } from '@material-ui/core'

export const widthSM = 880
export const widthXS = 466
export const widthXL = 1180
const theme = createMuiTheme({
  layout: {
    rootHeight: '100%',
    gridMainFormMaxWidth: 1180,
    gridMainFormPadding: '0 6.2rem 0 6.2rem',
    gridMainFormPaddingDownWidthSM: 0,
    gridWorkAreaMaxWidth: 940,
    gridWorkAreaPaddingLeft: 16,
    gridWorkAreaPaddingLeftDownWidthSM: 0,
    gridWorkAreaMargin: '0 auto',
    gridWorkAreaMinHeight: 200,
    gridWorkAreaMinHeightDownWidthXS: 70,
    gridItemPadding: '12px 0',
    gridItemPaddingDownWidthXS: '5px 0',
    gridButtonMargin: '2rem 0 0 0',
    gridTypographyTextFontSize: '1.8rem',
    gridTypographyTextFontWeight: 400,
    gridTypographyTextFontSizeWidthXS: '1.3rem',
    gridTypographyTextLetterSpacing: '0.45px',
    gridTypographyTextMargin: '1.8rem 0 1.2rem 0',
  },
  palette: {
    primary: {
      ERVBlue: '#35347e',
      White: '#FFFFFF',
      WhiteSmoke: '#EBEBEB',
      AliceBlue: '#EDF8FF',
      Nobel: '#9B9B9B',
      NightRider: '#333333',
      Citrus: '#BEB400',
      Sandwisp: '#E0DA7F',
      WhiteAlmost: '#FEFEFE',
      Cinnabar: '#E84040',
      Seagull: '#78A7CD',
      Empress: '#737373',
      Gainsboro: '#DBDBDB',
      fontFamily: 'Neo Sans Pro',
      fontW1G: 'Neo Sans Pro',
      fontW1GRegular: 'Neo Sans Pro, sans-serif',
      main: '#003C78',
      paragraphFont: '#807900',
      orange: '#E08100',
    },
  },
  breakpoints: {
    keys: ['xs', 'sm', 'md', 'lg', 'xl'],
    values: {
      xs: 466,
      sm: 880,
      xl: 1180,
    },
  },
})

theme.props = {
  MuiInputLabel: {
    shrink: true,
  },
  MuiInput: {
    disableUnderline: true,
  },
}

theme.overrides = {
  MuiInput: {
    root: {
      border: '1px solid #9b9b9b',
      flexGrow: 1,
      flexShrink: 1,
      width: '100%',
      paddingLeft: '1.2rem',
      paddingRight: '1.2rem',
      [theme.breakpoints.down(widthXS)]: {
        fontSize: '0.8rem',
        paddingRight: '0.6rem',
        paddingLeft: '0.6rem',
      },
    },
    formControl: {
      'label + &': {
        marginTop: '0.6rem',
        [theme.breakpoints.down(widthXS)]: {
          marginTop: '0.6rem',
        },
      },
    },
    input: {
      '&::placeholder': {
        fontStyle: 'italic',
        textTransform: 'initial',
      },
    },
    error: {
      '&.MuiFormHelperText-root.Mui-error': {
        marginTop: theme.spacing(2),
        color: theme.palette.primary.Cinnabar,
      },
    },
  },
  MuiInputLabel: {
    root: {
      fontSize: '1rem',
      [theme.breakpoints.down(widthXS)]: {
        fontSize: '0.8rem',
      },
      color: theme.palette.primary.ERVBlue,
      fontWeight: 600,
      fontFamily: theme.palette.primary.fontW1G,
      letterSpacing: 0.24,
      paddingBottom: 5,
    },
    formControl: {
      position: 'relative',
    },
    asterisk: {
      content: '*',
      fontSize: '1rem',
      fontWeight: 600,
      color: theme.palette.primary.Citrus,
    },
    shrink: {
      transform: 'translate(0px, 0px) scale(1)',
    },
    outlined: {
      '&$shrink': {
        transform: 'translate(0px, 0px) scale(1)',
      },
      zIndex: 0,
    },
  },
  MuiInputBase: {
    root: {
      fontFamily: theme.palette.primary.fontW1G,
      border: '1px solid #9b9b9b',
      padding: '0.5rem',
      marginTop: '0.6rem',
      [theme.breakpoints.down(widthXS)]: {
        padding: '0',
      },
    },
  },
  MuiButton: {
    root: {
      fontWeight: 0,
      minWidth: 35,
    },
    endIcon: {
      marginLeft: 12,
      marginRight: -8,
    },
    text: {
      padding: '1px 1px',
    },
  },
  MuiFormLabel: {
    root: {
      [theme.breakpoints.down(widthXS)]: {
        fontSize: '0.8rem',
      },
      color: theme.palette.primary.ERVBlue,
      fontWeight: 600,
      fontFamily: theme.palette.primary.fontW1G,
      letterSpacing: 0.24,
    },
  },
  MuiOutlinedInput: {
    root: {
      borderRadius: 0,
    },
  },

  MuiAutocomplete: {
    root: {
      flexGrow: 1,
      flexShrink: 1,
      width: '100%',
      fontFamily: theme.palette.primary.fontW1G,
    },
    inputRoot: {
      '&&[class*="MuiOutlinedInput-root"] $input': {
        padding: '4px 0 7px',
        [theme.breakpoints.down(widthXS)]: {
          padding: 4,
          fontSize: '0.8rem',
        },
      },
      '&[class*="MuiOutlinedInput-root"]': {
        [theme.breakpoints.down(widthXS)]: {
          padding: 2,
          fontSize: '0.8rem',
        },
      },
    },
    listbox: {
      padding: 0,
      position: 'absolute',
      border: `1px solid ${theme.palette.primary.Nobel}`,
      boxShadow: '0 2px 0.25rem rgba(0, 0, 0, 0.15)',
      margin: `-0.3rem 0 0 -1px`,
      [theme.breakpoints.down(widthXS)]: {
        margin: `-0.3rem 0 0 0px`,
      },
      '& li': {
        fontFamily: theme.palette.primary.fontW1G,
        [theme.breakpoints.down(widthXS)]: {
          fontSize: '0.8rem',
          padding: '0px 4px',
        },
      },
      backgroundColor: '#fff',
      '& li[data-focus="true"]': {
        backgroundColor: '#e6f7ff',
      },
      '& li[aria-selected="true"]': {
        fontWeight: 600,
        backgroundColor: '#e6f7ff',
      },
    },
  },
  MuiIconButton: {
    root: {
      padding: 0,
    },
  },
  MuiPaper: {
    rounded: {
      borderRadius: 0,
    },
    elevation1: {
      boxShadow: 'none',
    },
  },
  PrivateNotchedOutline: {
    root: {
      display: 'none',
    },
  },
  MuiFormHelperText: {
    contained: {
      marginLeft: 0,
      marginRight: 0,
    },
  },
  MuiTableBody: {
    root: {
      fontWeight: '1rem',
      [theme.breakpoints.down(widthXS)]: {
        fontSize: '0.8rem',
      },
    },
  },
  MuiTableCell: {
    sizeSmall: {
      [theme.breakpoints.down(widthXS)]: {
        padding: '6px 0 6px 0',
      },
      '&:last-child': {
        [theme.breakpoints.down(widthXS)]: {
          paddingRight: 0,
        },
      },
    },
  },
  // MuiPickersCalendarHeader: {
  //   switchHeader: {
  //     color: theme.palette.primary.main,
  //   },
  //   dayLabel: {
  //     color: theme.palette.primary.main,
  //   },
  // },
}

export default theme
